import styled from 'styled-components'

export const ChoicesConatiner = styled.div`
  margin-top: 32px;
  &:first-child {
    margin-top: 0px;
  }
`
